export default __webpack_public_path__ + "static/media/AmazoneLogin.4474adb2.png";